import React from 'react';
import { KpiGrid, type KpiItem } from '@/components/ui/KpiGrid';
import { Calculator, Pencil, Clock, CheckCircle2, XCircle, DollarSign } from 'lucide-react';

export function EstimatesKpiDashboard() {
  const kpis: KpiItem[] = [
    {
      title: 'Tổng Hồ Sơ',
      value: 145,
      suffix: 'Dự toán',
      icon: Calculator,
      color: 'text-indigo-600',
      bg: 'bg-indigo-50',
      trend: 'up',
      trendValue: 'Tháng này',
      chartColor: 'bg-indigo-500',
      chartData: [120, 125, 130, 135, 140, 142, 145]
    },
    {
      title: 'Đang Lập',
      value: 12,
      suffix: 'Hồ sơ',
      icon: Pencil,
      color: 'text-blue-600',
      bg: 'bg-blue-50',
      trend: 'up',
      trendValue: 'Chưa chốt',
      chartColor: 'bg-blue-500',
      chartData: [8, 9, 10, 11, 10, 11, 12]
    },
    {
      title: 'Chờ Duyệt',
      value: 8,
      suffix: 'Hồ sơ',
      icon: Clock,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      trend: 'down',
      trendValue: 'Đang review',
      chartColor: 'bg-amber-500',
      chartData: [15, 12, 10, 8, 9, 8, 8]
    },
    {
      title: 'Trúng Thầu',
      value: 85,
      suffix: 'Hồ sơ',
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Đã ký HĐ',
      chartColor: 'bg-emerald-500',
      chartData: [70, 75, 78, 80, 82, 84, 85]
    },
    {
      title: 'Trượt Thầu',
      value: 15,
      suffix: 'Hồ sơ',
      icon: XCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      trend: 'down',
      trendValue: 'Phân tích lý do',
      chartColor: 'bg-red-500',
      chartData: [18, 17, 16, 16, 15, 15, 15]
    },
    {
      title: 'Tổng Giá Trị',
      value: 125.5,
      suffix: 'Tỷ',
      icon: DollarSign,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      trend: 'up',
      trendValue: 'Dự kiến',
      chartColor: 'bg-emerald-500',
      chartData: [100, 105, 110, 115, 120, 122, 125.5]
    }
  ];

  return <KpiGrid kpis={kpis} />;
}
